import type { Essentials, ISiteContext } from '../../../../models';
import { isAppSupportedInResponsiveEditors } from './editor-not-supported/api';
import { AppNotificationType, type AppNotification } from './types';

export async function getAppNotification({
  httpClient,
  rpcClient,
  app,
  editorType,
}: {
  httpClient: Essentials['httpClient'];
  rpcClient?: Essentials['rpcClient'];
  app: {
    id: string;
    name: string;
  };
  editorType: ISiteContext['editorType'];
}): Promise<AppNotification | null> {
  const { supportedInEditorX, supportedInStudio } =
    await isAppSupportedInResponsiveEditors({
      httpClient,
      rpcClient,
      appId: app.id,
    });

  if (
    (editorType === 'STUDIO' && !supportedInStudio) ||
    (editorType === 'EDITORX' && !supportedInEditorX)
  ) {
    return {
      type: AppNotificationType.EditorNotSupported,
      data: {
        appName: app.name,
        editorType,
      },
    };
  }

  return null;
}
